import { Box, styled } from "@mui/material";

export const StyledInfo = styled(Box)(({ theme }) => ({
  ".header": {
    height: "15rem",
    background: theme.color.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    h1: {
      color: theme.color.background,
    },
  },
  ".content": {
    margin: "5rem auto",
    padding: "5rem",
    width: "60%",
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    boxShadow: `0px 4px 15px 0px rgba(0,0,0,0.75)`,
    ".imageWrapper": {
      width: "45rem",
      img: {
        width: "100%",
        height: "100%",
      },
    },
    ".divider": {
      width: "4px",
      height: "30rem",
      background: theme.color.contrastColor,
    },
    ".text": {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      p: {
        fontSize: "1.3rem",
        lineHeight: "1.8rem",
        fontFamily: "'Indie Flower', cursive",
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
    ".header": {
      height: "25vh",
    },
    ".content": {
      width: "90%",
      margin: "2rem auto",
      padding: "3rem",
      flexDirection: "column",
      boxSizing:"border-box",
      ".imageWrapper": {
        width: "15rem",
      },
      ".divider": {
        width: "90%",
        height: "4px",
      },
      ".text": {
        textAlign: "center"
      },
    },
  },
}));
